<template>
  <NuxtLoadingIndicator
    class="loading-indicator"
    :color="configuredTheme.colorHex ?? '#000000'"
  />
</template>

<script lang="ts" setup>
import { useBrandThemeStore } from '@@fire-b2b/stores/brandTheme'

const { configuredTheme } = storeToRefs(useBrandThemeStore())
</script>
